export enum DEV_HOSTS {
    DEV = 'dev',
    LOCALHOST = 'localhost',
}
